module.exports = __webpack_public_path__ + "media/images/online_talks/ZYVO-851a3957c109802e6bf2bc93c0768d62.png";